import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const interestedIn = z
    .union([
    z.literal("Custom Packaging / Rollstock"),
    z.literal("Co-Packing"),
    z.literal("Creative Services"),
    z.literal("Stock Packaging"),
    z.string(),
])
    .describe(createCustomSettings({ isCheckBoxList: true, label: "Interested In" }));
//# sourceMappingURL=interests-list.js.map